import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps, SelectedBusiness } from "../../containers/Wizard";
import { LAST_NAME_PATH, CONTACT_PHONE_PATH } from "../../routing/paths";
import SimpleStep from "../SimpleStep";
import { notBlank } from "../../shared/validations";

const simpleStepProps = {
  previous: LAST_NAME_PATH,
  next: CONTACT_PHONE_PATH,
  question: "What's your role in",
  description: "Your title or a brief description of your duties.",
  placeholder: "Owner",
  spellName: "role",
  type: "text",
  validation: notBlank,
};

export const RoleStep: FunctionComponent<WizardProps> = (props: WizardProps) => {
  let bizName: string;
  const biz: SelectedBusiness = props.invocations["business"] as SelectedBusiness;
  if (biz) bizName = biz["name"];
  else bizName = String(props.invocations["business_name"] || "");

  const roleProps = Object.assign({}, simpleStepProps, { target: bizName });
  return <SimpleStep wizard={props} {...roleProps} />;
};

export default WizardContainer(RoleStep);
